import React from 'react';
import './Home.css';

function Home() {
  return (

<div className="gradient-background">
      <div className="text-content">
      <div className="static-star-static-star11"></div>
        <div className="static-star static-star22"></div>
        <div className="static-star static-star33"></div>
        <div className="static-star static-star44"></div>
        <div className="static-star static-star55"></div>
        <div className="static-star static-star66"></div>
        <div className="static-star static-star77"></div>
        <div className="static-star static-star88"></div>
        <div className="static-star static-star99"></div>
        <div className="static-star static-star1a"></div>
        <div className="static-star static-star1b"></div>

        <div class="star rotating-star11"></div>
      <div class="star rotating-star22"></div>
      <div class="star rotating-star33"></div>
      <div class="star rotating-star44"></div>
      <div class="star rotating-star55"></div>
      <div class="star rotating-star66"></div>
      <div class="star rotating-star77"></div>
      {/* <div class="star static-star1"></div>
      <div class="star static-star2"></div>
      <div class="star static-star3"></div>
      <div class="star static-star4"></div>
      <div class="star static-star5"></div> */}
      <div className='homepage_header_paragraph'>
        <h1>Holistic Development.</h1>
        <p>
        At Sai Shanti Vidya Niketan, we focus on the holistic development of each child. Our curriculum is designed to nurture cognitive, social, emotional, and physical growth, ensuring a well-rounded education.
        </p>
        </div>
        {/* <div className="search-bar">
          <input type="text" placeholder="Search Courses" style={{backgroundColor:"white"}}/>
          <button>Search Courses</button>
        </div> */}

      </div>
      <div className="container">
        <div className="image-back">
          <img
            loading="lazy"
            decoding="async"
            src="./slider-2-circel.jpg"
            className="attachment-full size-full wp-image-8413 rotate"
            alt=""
            srcSet="./slider-2-circel.jpg 100w"
            sizes="(max-width: 900px) 100vw, 900px"
          />
        </div>
        <div className="image-front">
          <img
            fetchpriority="high"
            decoding="async"
            src="./heroimage.png"
            className="attachment-full size-full wp-image-8417"
            alt=""
            srcSet="./heroimage.png 900w, ./heroimage.png 686w, ./heroimage.png 768w"
            sizes="(max-width: 900px) 100vw, 900px"
          />
        </div>

        <div className="static-star static-star1"></div>
        <div className="static-star static-star2"></div>
        <div className="static-star static-star3"></div>
        <div className="static-star static-star4"></div>
        <div className="static-star static-star5"></div>
        <div className="static-star static-star6"></div>
        <div className="static-star static-star7"></div>
        <div className="static-star static-star8"></div>

        <div class="star rotating-star1"></div>
      <div class="star rotating-star2"></div>
      <div class="star rotating-star3"></div>
      <div class="star rotating-star4"></div>
      <div class="star rotating-star5"></div>
      <div class="star static-star1"></div>
      <div class="star static-star2"></div>
      <div class="star static-star3"></div>
      <div class="star static-star4"></div>
      <div class="star static-star5"></div>
      </div>
    </div>
  );
}

export default Home;
